import {useContext} from 'react';
import {CurrencyContext} from 'app/contexts/currencyContext';

const useCurrency = () => useContext(CurrencyContext);

export default useCurrency;
